module.exports = __webpack_public_path__ + "img/6-oneImg.3982b920.png";